// For handling localStorage update from broker's sign in link
export function extractResponseType(url) {
  const regex = /response_type=([^&]*)/i;
  const match = url?.match(regex);
  if (match && match?.[1]) {
    return match?.[1];
  } else {
    return null;
  }
}

export function extractState(url) {
  const regex = /state=([^&]*)/i;
  const match = url?.match(regex);
  if (match && match?.[1]) {
    return match?.[1];
  } else {
    return null;
  }
}

export function extractClientId(url) {
  const regex = /client_id=([^&]*)/i;
  const match = url?.match(regex);
  if (match && match?.[1]) {
    return match?.[1];
  } else {
    return null;
  }
}

export function extractScope(url) {
  const regex = /scope=([^&]*)/i;
  const match = url?.match(regex);
  if (match && match?.[1]) {
    return match?.[1]?.replaceAll('+', ' ');
  } else {
    return null;
  }
}

export function extractRedirectUri(url) {
  const regex = /redirect_uri=([^"]*)/i;
  const match = url?.match(regex);
  if (match && match?.[1]) {
    return decodeURIComponent(match?.[1]);
  } else {
    return null;
  }
}
